import { render, staticRenderFns } from "./VolumeBar.vue?vue&type=template&id=165ad1ed&scoped=true&"
import script from "./VolumeBar.vue?vue&type=script&lang=js&"
export * from "./VolumeBar.vue?vue&type=script&lang=js&"
import style0 from "./VolumeBar.vue?vue&type=style&index=0&id=165ad1ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ad1ed",
  null
  
)

export default component.exports